import styled from '@emotion/styled/macro'
import { Accordion as MuiAccordion } from '@mui/material'
import theme from 'theme'

export const Accordion = styled(MuiAccordion)`
  border-radius: ${theme.attributes.borderRadius.tertiary};
  border: 1px solid ${theme.colors.borderMedium};
  background: ${theme.colors.devicesRowOddBg};
  width: 100%;

  html[data-theme='light'] & {
    /* MUI Accordion is a Paper with elevation=1; the card is defined by its stroke instead */
    box-shadow: none;
  }

  .MuiAccordionSummary-root {
    border-radius: ${theme.attributes.borderRadius.quaternary};
    border: 1px solid ${theme.colors.borderMedium};
    border-bottom: none;
    background: ${theme.colors.devicesRowOddBg};
    width: 100%;
    height: 68px;

    html[data-theme='light'] & {
      /* the chevron's colour is set via htmlColor (inline), so it needs !important to lose */
      .MuiAccordionSummary-expandIconWrapper svg {
        color: ${theme.colors.devicesSecondaryText} !important;
      }
    }

    .summary-logo-image {
      min-width: 44px !important;
      min-height: 44px !important;
      height: 44px !important;
      width: 44px !important;
      border-radius: ${theme.attributes.borderRadius.mediumSmall};
      object-fit: contain;
      background: ${theme.colors.surfaceContainerBackground};
      flex-shrink: 0;
    }

    .missing-vendor-logo {
      display: flex;
      align-items: center;
      justify-content: center;
      background: #c3c3c3;
      border-radius: ${theme.attributes.borderRadius.circle};
      color: ${theme.baseColors.greyscale[0]};
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.header};
      font-weight: ${theme.typography.fontWeight.bold};
      min-width: 44px !important;
      min-height: 44px !important;
      height: 44px !important;
      width: 44px !important;
      flex-shrink: 0;
    }

    &.Mui-expanded {
      border-radius: ${theme.attributes.borderRadius.secondary} ${theme.attributes.borderRadius.secondary} 0 0;
    }

    .MuiAccordionSummary-content {
      display: flex;
      align-items: center;
      gap: ${theme.spacing.small}px;
      margin-top: ${theme.spacing.small}px;
      margin-bottom: ${theme.spacing.small}px;
      min-width: 0;
      overflow: hidden;

      .product-name-wrapper {
        display: flex;
        flex-direction: column;
        gap: ${theme.spacing.half}px;
        justify-content: center;
        min-width: 0;
        overflow: hidden;

        .product-name {
          color: ${theme.colors.menuItemText};
          font-family: ${theme.typography.fontFamily.primary};
          font-size: ${theme.typography.fontSize.large};
          font-style: normal;
          font-weight: ${theme.typography.fontWeight.extraThick};
          line-height: 20px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .product-summary-space {
        flex-grow: 1;
      }
    }
  }

  .MuiCollapse-wrapper {
    background: ${theme.colors.frameworkCardBg};
    border-radius: ${theme.attributes.borderRadius.secondary};

    .MuiAccordionDetails-root {
      padding: ${theme.spacing.md}px ${theme.spacing.medium}px ${theme.spacing.medium}px;
      border: 1px solid ${theme.colors.borderMedium};
      border-top: none;
      background: ${theme.colors.devicesRowOddBg};
      border-bottom-left-radius: ${theme.attributes.borderRadius.quaternary};
      border-bottom-right-radius: ${theme.attributes.borderRadius.quaternary};

      .description {
        color: ${theme.colors.calendarDay};
        font-family: ${theme.typography.fontFamily.primary};
        font-size: ${theme.typography.fontSize.large};
        font-style: normal;
        font-weight: ${theme.typography.fontWeight.normal};
        line-height: 20px;
        letter-spacing: 0.25px;
      }
    }
  }
`
